if (!customElements.get('mp-quote')) {
  customElements.define('mp-quote', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this._form = this.querySelector('.mp-rfq-form');
      this._required = Array.from(this.querySelectorAll('input[type="text"][required], textarea[required]'));
      const validate = field => field.setCustomValidity(field.value.length && !field.value.trim() ? this.dataset.rfqSpaces : '');
      this._required.forEach(field => {
        field.addEventListener('input', () => validate(field), options);
        field.addEventListener('change', () => validate(field), options);
        validate(field);
      });
      this._form?.addEventListener('invalid', event => {
        if (!(event.target instanceof Element)) return;
        for (let parent = event.target.parentElement; parent && parent !== this; parent = parent.parentElement) {
          if (parent.tagName === 'DETAILS') parent.open = true;
        }
      }, { ...options, capture: true });
      document.addEventListener('shopify:block:select', event => {
        if (!(event.target instanceof Element) || !this.contains(event.target)) return;
        const details = event.target.matches('details') ? event.target : event.target.querySelector('details');
        if (details) details.open = true;
      }, options);
      const status = this.querySelector('[data-rfq-status]');
      if (status) this._statusFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        status.focus({ preventScroll: true });
        const headerHeight = document.querySelector('[data-mp-header-bar]')?.getBoundingClientRect().height || 0;
        const bounds = status.getBoundingClientRect();
        if (bounds.top < headerHeight || bounds.top > window.innerHeight - 80) status.scrollIntoView({ behavior: 'instant', block: 'start' });
      });
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      cancelAnimationFrame(this._statusFrame);
      this._required?.forEach(field => field.setCustomValidity(''));
    }
  });
}
